export const USER_COUNTRIES_COUNT_UPDATED_EVENT = 'gt:user-countries-count-updated';

export type UserCountriesCountUpdatedDetail = {
  userId: string;
  count: number;
};

/** Keep the same user object when the count did not change, so route effects are not retriggered. */
export function userWithCountryCount<T extends { _id: string; countries_count?: number }>(
  prev: T | null,
  detail: UserCountriesCountUpdatedDetail | undefined,
): T | null {
  if (!prev || !detail?.userId || prev._id !== detail.userId) return prev;
  if (prev.countries_count === detail.count) return prev;
  return { ...prev, countries_count: detail.count };
}

export function dispatchUserCountriesCountUpdated(detail: UserCountriesCountUpdatedDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<UserCountriesCountUpdatedDetail>(USER_COUNTRIES_COUNT_UPDATED_EVENT, {
      detail,
    }),
  );
}
